import { LayoutConfig, DIALOG_TYPE } from '@spartacus/storefront';
import { UigSavedCartFormDialogComponent } from './uig-saved-cart-form-dialog.component';

export const uigSavedCartFormLayoutConfig: LayoutConfig = {
    launch: {
      SAVED_CART: {
        inline: true,
        component: UigSavedCartFormDialogComponent,
        dialogType: DIALOG_TYPE.DIALOG,
      },
    },
  };
  